module.exports = __webpack_public_path__ + "img/obs-game-capture.e2e67d15.png";